import { Component, OnInit, AfterViewInit } from '@angular/core';
import { GeneralService } from '../../services/general.service';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-indicate',
  templateUrl: './indicate.component.html',
  styleUrls: ['./indicate.component.scss']
})
export class IndicateComponent implements OnInit, AfterViewInit {

  init = false;

  formGroup: FormGroup;

  constructor( 
    public gs : GeneralService,
    private formBuilder: FormBuilder) {

  }

  ngOnInit() {
    this.formGroup = this.formBuilder.group({
        type: ['Corretor', [Validators.required]],
        city: ['', [Validators.required]],
        name: ['', [Validators.required]],
        phone: ['', [Validators.required]]
      }
    );
    this.gs.setTitle('Indicar um amigo');
  }

  ngAfterViewInit(){
    setTimeout(() => this.init = true,200);
  }

  send(event){
    
  }

}